import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, ExternalLink } from "lucide-react";
import { images, lodge as staticLodge } from "../data/content";
import { useSiteContent } from "../lib/cms";

export default function Footer() {
  const lodge = { ...staticLodge, ...useSiteContent().block("visit_details") };
  return (
    <footer className="bg-paper-texture bg-sapphire-deep text-parchment" data-testid="site-footer">
      <div className="container-lodge grid gap-12 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={images.crestSeal} alt="Lodge coat of arms" className="h-16 w-16" />
            <div className="font-display text-xl">
              The Zetland in the East
              <span className="block font-sans text-[10px] uppercase tracking-[0.3em] text-gold">
                Lodge No. 508 E.C. · Est. 1845
              </span>
            </div>
          </div>
          <p className="mt-5 max-w-md font-sans text-sm leading-relaxed text-parchment/70">
            Singapore's oldest Masonic lodge, meeting under the English Constitution within the
            District Grand Lodge of the Eastern Archipelago. Making good men better since 1845.
          </p>
        </div>

        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.25em] text-gold">Visit</h4>
          <ul className="mt-4 space-y-3 font-sans text-sm text-parchment/75">
            <li className="flex gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
              <span>{lodge.address}</span>
            </li>
            <li className="flex gap-2">
              <Mail size={16} className="mt-0.5 shrink-0 text-gold" />
              <a href={`mailto:${lodge.emailSecretary}`} className="hover:text-gold">
                {lodge.emailSecretary}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.25em] text-gold">Governance</h4>
          <ul className="mt-4 space-y-3 font-sans text-sm text-parchment/75">
            <li>
              <a href="https://www.ugle.org.uk" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-gold">
                United Grand Lodge of England <ExternalLink size={12} />
              </a>
            </li>
            <li>
              <a href="https://easternarchipelago.org" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-gold">
                District GL Eastern Archipelago <ExternalLink size={12} />
              </a>
            </li>
            <li>
              <Link to="/login" className="hover:text-gold">Member Portal</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-lodge flex flex-col items-center justify-between gap-2 py-5 font-sans text-xs text-parchment/50 md:flex-row">
          <p>© {new Date().getFullYear()} The Zetland in the East Lodge No. 508 E.C.</p>
          <p className="tracking-widest uppercase">Audi · Vide · Tace</p>
        </div>
      </div>
    </footer>
  );
}
